<template>
  <div id="finish">
    <div>
      <div class="msg">
        <div class="icon"><img src="@/assets/image/rateLev_5.svg"></div>

        <p>{{lang.msg_finish_review}}</p>
        <!-- <h3>{{lang.msg_finish_thank_html}}</h3> -->
        <h4 v-html="lang.msg_finish_thank_html"></h4>
        <!-- <small>{{lang.guide_mag_thank}}</small> -->

      </div>

      <div class="infor" v-if="isAd">
        <div class="ad">
          <!-- {{getAdObj.image}} -->
          <div class="img" v-show="isAd" :style="getAdObj.image?bgImagesUrl(getAdObj.image):''"
            @click="lined(getAdObj.link)"></div>
          <div class="txt">AD</div>
        </div>

        <div class="istay">
          <a href="http://istay.io" :target="'target'">
            <img src="@/assets/images/istay-orange-text.png" alt="">
          </a>
        </div>
      </div>

      <Footer v-else />


    </div>
   
  </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex'
import Footer from '@/components/layout/Footer'
export default {
    name: 'Finish',
    components: {
      Footer
    },
    props: ['lang'],

    data(){
      return {
        isAd: false,
        ad: {
          image: '',
          link: '',
        }
      }
    },
    created(){
      this.getAd().then(res=>{
        if(res.status===200){
          
          this.isAd = true;
          this.ad = {...res.message};
        }
          
        });
    },
    computed: {
      ...mapGetters(['getAdObj'])
    },
    methods: {
      ...mapActions(['getAd']),
      lined(payload){
        
        
        if(payload){
          location.href=payload
        }
        
      },
          bgImagesUrl(url){
            return {
                'background-image': `url(${url})`
            }
        },
    },

}
</script>

<style lang="scss" scoped>
$gray-200: #f4f4f4;
  #finish {
    position: relative;
    // @include size(100vw, calc(100vh - 40px));
    @include flexs-direction();
    

    >div {
      @include flexs(center, flex-start, column);
      min-height: calc(100vh - 80px);
      margin-top: 40px;
      
      div.msg {
        // flex: 1;
        margin-bottom: 16px;
        @include flexs(center, center, column);

        * {
          margin-bottom: 16px;
          word-break: keep-all;
          text-align: center;
        }

        .icon {
          margin: 0 auto 2rem;
          @include size(56px, 56px);
          background-color: $color-point;
          border-radius: 100%;
          position: relative;
          margin-bottom: 24px;

          img {
            filter: brightness(0) invert(1);
            @include transform;
            width: 40px;
          }
        }

        h4> ::v-deep b {
          color: $color-point;
        }

        small {
          margin: 0 2rem;
          color: $color-border;
          text-align: center;
          display: inline-block;
        }
      }
      div.infor{
        @include size(100%, 100%)
      }
      div.ad {
        // background-color: $gray-200;
        position: relative;
        width: calc(100% - 88px);
        padding-top: calc(100% - 88px);
        
        margin: 0 auto 0;
        border: 1px solid $gray-200;
        border-bottom: 0;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        .img{
          @include size(100%, 100%);
          @include positions(absolute, 0, 0, 0, 0);
          @include bg(cover);
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        }


        .txt {
          @include positions(absolute, -12px, -4px, unset, unset);
          background-color: $color-point;
          padding: 4px 6px;
          font-size: 75%;
          color: #FFFFFF;
          border-radius: 6px;

        }

    
      }
        .istay{
          @include size(calc(100% - 88px), 56px);
          @include flexs-align(center, flex-end);
          padding: 0 8px;
          border: 1px solid $gray-200;
          margin: 0 auto 0;
           border-bottom-right-radius: 8px;
          border-bottom-left-radius: 8px;
          a{
            display: flex;
            img{
                height: 24px;
            }
          }
        }
      
    }





  }
  footer{
    @include positions(fixed, unset, 0, 0, 0);
  }
</style>